import { computed } from "vue";
import { useStorage } from "@vueuse/core";
import dayjs from "dayjs";
import { userSSOApi } from "@/api/adapters/external-auth";

const authToken = useStorage<string>("authToken", null, localStorage, { flush: "sync" });
const authExpiresAt = useStorage<string>("authExpiresAt", null, localStorage, { flush: "sync" });
const authProvider = useStorage<string>("authProvider", "telegraph", localStorage, { flush: "sync" });
const logoutUrl = useStorage<string>("logoutUrl", "/logout", localStorage, { flush: "sync" });
export function useAuthSession() {
  function clearStorage() {
    authToken.value = null;
    authExpiresAt.value = null;
  }

  const hasSession = computed(() => {
    if (!authToken.value || !authExpiresAt.value) {
      return false;
    }

    return dayjs(authExpiresAt.value).isAfter(dayjs());
  });

  const sessionExpired = computed(() => !authExpiresAt.value || dayjs(authExpiresAt.value).isBefore(dayjs()));

  const loginRoute = computed(() => {
    return authProvider.value === "telegraph" ? { name: "login" } : { name: "oauthLogin" };
  });

  async function getSSOUser(token: string) {
    const user = await userSSOApi.getUser(token);
    if (!user) {
      throw new Error("Unable to retrieve SSO user.");
    }
    return user;
  }

  return {
    authToken,
    authExpiresAt,
    authProvider,
    logoutUrl,
    hasSession,
    sessionExpired,
    loginRoute,
    getSSOUser,
    clearStorage,
  };
}
